<template>
    <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
      <v-dialog v-model="permitted_dialog" max-width="400px">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
              <p>{{message}}</p>
              <v-progress-circular
                :size="70"
                :width="2"
                :value="100"
                color="error"
                class="mb-4 mr-4"
              >
                <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
              </v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container v-else v-show="permitted != null" class="pt-0" fluid>
      <v-snackbar
        :value="showMessage()"
        multi-line
        color="#686868"
        top
        
      >
        {{message}}
      </v-snackbar>
    
      <v-dialog persistent v-model="BlockingViolation" max-width="400px">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-information-outline</v-icon>Blocking Value Violation</div>
              <p>Due to the Blocking Value set on the Client, the specified amount cannot be captured</p>
            </div>
          </v-card-text>
    
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="BlockingViolation = false">
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    
      <v-card flat >
      <v-toolbar dense flat color="#2A353D">
        <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Unit Distribution</v-toolbar-title>
        <v-spacer/>
        <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
        <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>  </v-toolbar>
      </v-card>
    
    <!-- ********************************************************************************************CREATE**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->
    
      <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-card class="pt-3 mt-3" elevation="12">  
          <v-row class="ml-1 mr-1">
            <v-col class="pt-3 pb-0" cols="6">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="Distribution.UnitsDistributionDealNo"
                label="Deal Reference #"
                required :error-messages="BNerrors"
                placeholder="----"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="Distribution.EffectiveDate"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="Distribution.EffectiveDate"
                    label="Effective Date"
                    append-icon="mdi-calendar-month"
                    readonly placeholder="--/--/--"
                    dense outlined color="#2A353D"
                    :error-messages="errors"
                    :rules="CreateDateRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#2A353D" v-model="Distribution.EffectiveDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                <v-btn outlined small color="#2A353D" @click="$refs.menu.save(Distribution.EffectiveDate)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    v-model="Distribution.DistributionUnits"
                    label="Distribution per unit"
                    placeholder="------"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on" type="number"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-select
                    outlined dense
                    v-model="Distribution.UnitsCash"
                    :items="DistributionTypes"
                    item-text="Value"
                    item-value="ID"
                    placeholder="----"
                    :rules="[
                      v => (!!v || v == 0) || 'field is required'
                    ]"
                  ></v-select>               
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="Distribution.DistributionType"
                :items="DistributionTypes"
                item-text="Value"
                item-value="ID"
                placeholder="----"
                :rules="[
                  v => (!!v || v == 0) || 'field is required'
                ]"
                label="Distribution Type"
              ></v-select>

              <v-select
                outlined dense
                v-model="Distribution.InvestmentNameId"
                :items="allUnitTrustFunds"
                item-text="Description"
                item-value="UnitTrustFundId"
                placeholder="----"
                :rules="TextFieldRules"
                label="Fund Name"
              ></v-select>

              <!-- <v-btn class="white--text" block color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                Load and Distribute
              </v-btn> -->
            </v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="allocations_headers"
          :fixed-header="true"
          :items="DistDetails"
          disable-pagination
          hide-default-footer dense
          class="elevation-12 my-allocations-table mt-3"
        >
    
          <template v-slot:top >
            <v-toolbar dense flat>
              <v-toolbar-title class="grey--text caption font-weight-normal">Distribution List</v-toolbar-title>
              <v-spacer/>
            </v-toolbar>
          </template>
    
          <template v-slot:item.TotalDistribution="{ item }">
            {{Number(item.TotalDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.Charges="{ item }">
            {{Number(item.Charges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.NetDistribution="{ item }">
            {{Number(item.NetDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.OpeningBalance="{ item }">
            {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
    
          <template v-slot:footer >
            <v-divider class="mt-0"/>
            <v-row class="ml-2 mr-2">
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(DistDetails.length).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
                  label="List Count"
                  readonly placeholder="------"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(Distribution.TotalDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Total Distribution"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(Distribution.Charges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Charges/Taxes"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(Distribution.NetDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Net Distribution"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-2 mr-2">
              <v-col class="pb-0" cols="2">

              </v-col>
              <v-col class="pb-0">

              </v-col>
              <v-col class="pb-0">

              </v-col>
              <v-col class="pb-0" cols="6">
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
                  <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true || distributed == true" @click="createNew()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    load and Distribute
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-form>
    
    <!-- ********************************************************************************************EDIT**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->
    
      <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <span class="d-flex flex-row mt-2">
          <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentDistribution.UnitsDistributionDealNo}}</span></span>
          <v-spacer/>
          <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentDistribution.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span v-if="currentDistribution.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentDistribution.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentDistribution.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </span>
        <v-row class="ml-1 mr-1">
          <v-col class="pt-3 pb-0" cols="6">
            <v-text-field
              light dense outlined
              color="#2A353D"
              v-model="currentDistribution.UnitsDistributionDealNo"
              label="Deal Reference #"
              required :error-messages="BNerrors"
              placeholder="----"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ml-1 mr-1">
          <v-col class="py-0">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="currentDistribution.EffectiveDate"
              transition="scale-transition"
              offset-y readonly
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="currentDistribution.EffectiveDate"
                  label="Effective Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense outlined color="#2A353D"
                  :error-messages="errors"
                  :rules="CreateDateRules"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker color="#2A353D" v-model="currentDistribution.EffectiveDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
              <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentDistribution.EffectiveDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="currentDistribution.DistributionUnits"
                  label="Distribution per unit"
                  placeholder="------"
                  dense outlined color="#2A353D"
                  :rules="TextFieldRules"
                  v-bind="attrs" readonly
                  v-on="on" type="number"
                ></v-text-field>
              </v-col>
              <v-col class="py-0">
                <v-select
                  outlined dense
                  v-model="currentDistribution.UnitsCash"
                  :items="DistributionTypes"
                  item-text="Value"
                  item-value="ID"
                  placeholder="----"
                  :rules="[
                    v => (!!v || v == 0) || 'field is required'
                  ]" readonly
                ></v-select>               
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0">
            <v-select
              outlined dense
              v-model="Distribution.DistributionType"
              :items="DistributionTypes"
              item-text="Value"
              item-value="ID"
              placeholder="----"
              :rules="[
                v => (!!v || v == 0) || 'field is required'
              ]"
              label="currentDistribution Type"
              readonly
            ></v-select>

            <v-select
              outlined dense
              v-model="currentDistribution.InvestmentNameId"
              :items="allUnitTrustFunds"
              item-text="Description"
              item-value="UnitTrustFundId"
              placeholder="----"
              :rules="TextFieldRules"
              label="Fund Name" readonly
            ></v-select>

            <!-- <v-btn class="white--text" block color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              Load and Distribute
            </v-btn> -->
          </v-col>
        </v-row>

        <v-data-table
          :headers="allocations_headers"
          :fixed-header="true"
          :items="DistDetails"
          disable-pagination
          hide-default-footer dense
          class="elevation-12 my-allocations-table mt-3"
        >
    
          <template v-slot:top >
            <v-toolbar dense flat>
              <v-toolbar-title class="grey--text caption font-weight-normal">Distribution List</v-toolbar-title>
              <v-spacer/>
            </v-toolbar>
          </template>
    
          <template v-slot:item.TotalDistribution="{ item }">
            {{Number(item.TotalDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.Charges="{ item }">
            {{Number(item.Charges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.NetDistribution="{ item }">
            {{Number(item.NetDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
          <template v-slot:item.OpeningBalance="{ item }">
            {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
          </template>
    
          <template v-slot:footer >
            <v-divider class="mt-0"/>
            <v-row class="ml-2 mr-2">
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(DistDetails.length).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})"
                  label="List Count"
                  readonly placeholder="------"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(currentDistribution.TotalDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Total Distribution"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(currentDistribution.Charges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Charges/Taxes"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-7">
                <v-text-field
                  :value="Number(currentDistribution.NetDistribution).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  label="Net Distribution"
                  readonly placeholder="-----"
                  dense outlined color="#2A353D"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ml-2 mr-2">
              <v-col class="pb-0" cols="2">

              </v-col>
              <v-col class="pb-0">

              </v-col>
              <v-col class="pb-0">

              </v-col>
              <v-col class="pb-0" cols="6">
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-4" small color="#2A353D" @click="closeEdit()">close</v-btn>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-form>
    
    <!-- ********************************************************************************************TABLE**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->
    
      <v-data-table
        disable-pagination
        hide-default-footer
        :height="520"
        :headers="headers"
        :fixed-header="true"
        :items="confirmedDistributions ? allUnitDistributions : allUnitDistributions.filter(a => a.CheckerID === 0)"
        :search="search" v-if="!create &&  !edit"
        sort-by="MakeDate"
        sort-desc
        class="elevation-12 mt-2"
        @current-items="getFiltered"
      >
    
        <template v-slot:top >
    
          <v-dialog persistent v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>
    
              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    ok
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
    
          <v-dialog persistent v-model="reverseDialog" max-width="500px">
            <v-form flat ref="form" v-model="valid" lazy-validation>
              <v-card>
                <v-card-title>
                  <span class="grey--text text-center">Deal Reversal</span>
                </v-card-title>
    
                <v-card-text>
                  <span class="subtitle-1">{{reversal_description}}</span>
    
                  <v-textarea
                    class="mt-3"
                    label="Reversal Reason"
                    v-model="ReversalReason"
                    outlined rows="6"
                    row-height="15"
                    :rules="TextFieldRules"
                    placeholder="----"
                  ></v-textarea>
                </v-card-text>
    
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <div class="text-right mb-4">
                    <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                    <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                      <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      submit
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>          
            </v-form>
          </v-dialog>
    
          <v-container row>
            <v-text-field
              class="ml-3"
              hide-details
              outlined
              placeholder="search..."
              v-model="search"
              append-icon="mdi-magnify"
              dense
            ></v-text-field>
    
            <v-spacer></v-spacer>
    
            <v-btn v-if="showCreateBtn == true" v-show="confirmedDistributions" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
              Create New<v-icon small>mdi-plus</v-icon>
            </v-btn>
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" v-show="confirmedDistributions" outlined small color="#2A353D" class="ml-2">
                EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
              </v-btn>
              </template>
              <v-list dense>
              <v-list-item class="ma-0 pa-0">
                <v-btn @click="generatePDF(false)" text small color="#2A353D">
                  <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <download-excel
                    :data   = "CurrentDataset"
                    type    = "xls"
                    name    = "Unit Distributions.xls">
      
                    <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                  </download-excel>
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <download-excel
                    :data   = "CurrentDataset"
                    type    = "csv"
                    name    = "Unit Distributions.csv">
      
                    <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                  </download-excel>
                </v-btn>
              </v-list-item>
              </v-list>
            </v-menu>
            <v-btn @click="generatePDF(true)" v-show="confirmedDistributions" outlined small color="#2A353D" class="ml-2" v-on="on">
              PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
            </v-btn>
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
                CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
              </v-btn>
              </template>
              <v-list dense>
              <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getCustodians()">
    
              <v-list-item-title>
                {{ Currency.CurrencyName }}
              </v-list-item-title>
    
              </v-list-item>
              </v-list>
            </v-menu>
            <v-btn v-show="!confirmedDistributions" @click="confirmedDistributions = true" outlined small color="#2A353D" class="ml-2" v-on="on">
              ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
            </v-btn>
          </v-container>
        </template>
    
        <template v-slot:item.status="{ item }">
          <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
          <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.RejectionID == 0">pending</v-chip>
          <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
        </template>
    
        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!confirmedDistributions && item.CheckerID == 0" top>
    
          </v-tooltip>
          <v-tooltip v-if="!confirmedDistributions && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="updateStatus(item, true)"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>confirm</span>
          </v-tooltip>
          <v-tooltip v-if="!confirmedDistributions && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="reject(); setActiveDistribution(item, index)"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>reject</span>
          </v-tooltip>
          <!-- <v-btn
            v-show="confirmedDistributions"
            small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
            @click="TotalValue = item.Quantity * item.UnitPrice; setActiveDistribution(item, index); showEdit(); closeCreate()"
            color="#2A353D" class="mr-3"
          >
            <span>edit</span>
          </v-btn> -->
          <v-btn
            small outlined
            @click="view = true; setActiveDistribution(item, index); showEdit(); closeCreate()"
            color="#2A353D" class="mr-3"
          >
            <span>view</span>
          </v-btn>
          <v-tooltip v-if="confirmedDistributions" top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
                color="#2A353D" @click="setActiveDistribution(item, index); initReversal(item)"
              >
              mdi-backup-restore
              </v-icon>
            </template>
            <span>reverse</span>
          </v-tooltip>
        </template>
    
        <template v-slot:item.InvestmentNameId="{ item }">
          {{allUnitTrustFunds.filter(u => u.UnitTrustFundId == item.InvestmentNameId).map(u => u.Description)[0]}}
        </template>
    
        <!-- <template v-slot:item.AccountID="{ item }">
          {{getAccountName(item.AccountID)}}
        </template>
    
        <template v-slot:item.PurchaseDate="{ item }">
          {{ item.PurchaseDate | moment("DD MMM YYYY") }}
        </template>  -->
    
        <!-- <template v-slot:item.ValueDate="{ item }">
          {{ item.ValueDate | moment("DD MMM YYYY") }}
        </template>  -->
    
        <!-- <template v-slot:item.MakeDate="{ item }">
          {{ item.MakeDate | moment("DD MMMM YYYY") }}
        </template> -->
    
      </v-data-table>
    </v-container>
    </template>
    
    <script>
    import {mapGetters, mapActions} from "vuex";
    import UserService from '../services/user.service';
    import dealingService from '../services/dealing.service';
    import administrationService from '../services/administration.service';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable'
    
    export default {
      name: 'purchase_equtiy',
    
      data () {
        return {
          confirmedDistributions: true,
          edit: false,
          create:false,
          view: false,
          message: '',
          menu: false,
          dialog: false,
          reverseDialog: false,
          ReversalReason: '',
          reversal_description: '',
          overlay: false,
          permitted: null,
          permitted_dialog: true,
          loading: false,
          search: '',
          valid: true,
          distributed: false,
          content: '',
          currentDistribution: null,
          currentIndex: -1,
          CurrentDataset: [],
          headers: [
            {
              text: 'Deal Number',
              align: 'start',
              sortable: true,
              value: 'UnitsDistributionDealNo'
            },
            { text: 'Fund Name', value: 'InvestmentNameId', sortable: true },
            { text: 'Units', value: 'DistributionUnits', sortable: true },
            { text: 'UnitsCash', value: 'UnitsCash', sortable: true },
            { text: 'Status', value: 'status', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          allocations_headers: [
            {
              text: 'Holder\'s Name',
              align: 'start',
              sortable: true,
              value: 'FundName'
            },
            { text: 'Current Holding', value: 'InvestmentNameId', sortable: true },
            { text: 'Distribution', value: 'TotalDistribution', sortable: true },
            { text: 'Charge', value: 'Charges', sortable: true },
            { text: 'Net Distribution', value: 'NetDistribution', sortable: false, align: 'end' },
          ],
          TextFieldRules: [
            v => !!v || 'field is required',
          ],
          CreateDateRules: [
            v => !!v || 'field is required',
            v => (v <= this.currentSystemDate.DayDate) || 'Date must not exceed Purchase Date'
          ],
          EditDateRules: [
            v => !!v || 'field is required',
            v => (v <= this.currentDistributionDate) || 'Date must not exceed Purchase Date'
          ],
          // AllocatedValueRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
          // ],
          // AllocatedUnitsRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.Distribution.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
          // ],
          // EditAllocatedValueRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
          // ],
          // EditAllocatedUnitsRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.currentDistribution.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
          // ],
          CurrencyId: 0,
          DistributionTypes: [
            {ID: 1, Value: "Cash"},
            {ID: 0, Value: "Units"}
          ],
          Accounts: [],
          DistDetails: [],
          UnitPrice: 0,
          TotalValue: 0,
          RejectionStatus: 0,
          Distribution: {},
          errors: [],
          BlockingViolation: null,
          BNerrors: [],
        }
      },
    
      computed: {
        ...mapGetters([
          "allUnitDistributions",
          "allUnitTrustFunds",
          "allApplicationDefaults",
          "allCurrencies",
          "allRejectionReasons",
          "allDealers",
          "allUsers",
          "currentSystemDate",
          "allConfirmationSettings"
        ]),
    
        currentUser() {
          return this.$store.state.auth.user;
        },
        Currency() {
          return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
        },
        DealerID() {
          return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
        },
        showEditBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowEdit)) == 1){
            return true
          }
        }
        return false;
        },
    
        showCreateBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowCreate)) == 1){
            return true
          }
        }
        return false;
        },
    
        showConfirmBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowConfirm)) == 1){
            return true
          }
        }
        return false;
        },
    
        showReverseBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowReversal)) == 1){
            return true
          }
        }
        return false;
        },
    
        CheckerID(){
          if(this.allConfirmationSettings.filter(a => a.FunctionID == 323).map(a => a.Status)[0] == false){
            return this.currentUser.SecurityUserID
          } else {
            return 0
          }
        }
      },
    
      watch: {

      },
    
      created () {
        this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
      },
    
      methods: {
        ...mapActions([
          "createUnitDistribution",
          "updateUnitDistributionStatus",
        ]),
    
         async createNew() {
          this.message = '';
    
          await this.validate()
    
          if (this.valid == true) {
            this.loading = true;
            this.Distribution.MakerID = this.currentUser.SecurityUserID,
        
            this.createUnitDistribution(this.Distribution)
            .then(response =>{
              this.$socket.client.emit('socketreq', {
                commit: 'newUnitDistribution',
                data: response.data
              });
              this.distributed = true,
              this.Distribution = response.data.details
              this.DistDetails = response.data.dist_list
              this.message = response.data.message
              this.loading = false;
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            }) 
          }
        },
    
        // async update() {
        //   this.message = '';
    
        //   await this.validate()
    
        //   if (this.valid == true) {
        //     this.loading = true;
        //     this.currentDistribution.AvailAtTxn = Number(this.balances.Available) - Number(this.currentDistribution.InstrumentValue),
        //     this.currentDistribution.ActualAtTxn = this.balances.Actual,
        //     this.currentDistribution.CurrencyID = this.CurrencyId,
        //     this.currentDistribution.DealerID = this.DealerID,
        //     this.currentDistribution.SettlementDate = this.SettlementDate,
        //     this.currentDistribution.DealConfirmationDate = this.ConfirmationDate,
        //     this.currentDistribution.Tax = this.getTotalVAT(),
        //     this.currentDistribution.MakerID = this.currentUser.SecurityUserID,
        //     this.currentDistribution.LastUserID = this.currentUser.SecurityUserID,
        //     this.currentDistribution.CheckerID = 0,
        //     this.currentDistribution.CheckDate = null,
        //     this.currentDistribution.MakeDate = new Date(),
        //     this.currentDistribution.RejectionID = this.RejectionStatus,
    
        //     this.currentDistribution.charges = this.ChargesApplied,
        //     this.currentDistribution.taxes = this.TaxesApplied
    
        //     this.updatePurchase(this.currentDistribution)
        //     .then(response => {
        //       this.$socket.client.emit('socketreq', {
        //         commit: 'updPurchase',
        //         data: this.currentDistribution
        //       });
              
        //       this.message = response.data.message
        //       this.loading = false;
        //       this.closeEdit()
        //     },
        //     error => {
        //     this.message =
        //       (error.response && error.response.data.message) ||
        //       error.message ||
        //       error.toString();
        //       this.loading = false;
        //     })
        //   }
        // },
    
        updateStatus(item, status) {
          this.message = '';
          this.loading = true;
    
          if(status == true){
            item.CheckerID = this.currentUser.SecurityUserID,
            item.LastUserID = this.currentUser.SecurityUserID,
            item.CheckDate = new Date(),
            item.updatedAt = new Date(),
            item.RejectionID = this.RejectionStatus,
            item.IsConfirmation = status,
    
            this.updateUnitDistributionStatus(item)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'updUnitDistribution',
                data: item
              });
              
              this.message = response.data.message
              this.loading = false;
              this.closeEdit()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            }) 
          } else {
            this.currentDistribution.CheckerID = this.currentUser.SecurityUserID,
            this.currentDistribution.LastUserID = this.currentUser.SecurityUserID,
            this.currentDistribution.CheckDate = new Date(),
            this.currentDistribution.updatedAt = new Date(),
            this.currentDistribution.RejectionID = this.RejectionStatus,
            this.currentDistribution.IsConfirmation = status,
    
            this.updateUnitDistributionStatus(this.currentDistribution)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'updUnitDistribution',
                data: this.currentDistribution
              });
              
              this.message = response.data.message
              this.loading = false;
              this.closeEdit()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })        
          }
        },
    
        initReversal(item){
          var data = {
            FunctionID: 323,
            EntryID: item.PurchaseID,
            ReversalDate: this.currentSystemDate.DayDate
          }
          
          dealingService.initReversal(data)
          .then(response => {
            if(response.data.validation[0].fnResultClass == 1){
              this.reverseDialog = true
              this.reversal_description = response.data.description[0][0].description
            } else {
              this.message = response.data.validation[0].fnResult
            }
          })
        },
    
        async ReverseDeal(){
          this.message = '';
          await this.validate()
    
          if (this.valid == true) {
            var data = {
              ReversalID: 0,
              FunctionID: 323,
              EntityID: this.currentDistributionID,
              ReversalReason: this.ReversalReason,
              ReversalDate: this.currentSystemDate.DayDate,
              MakerID: this.currentUser.SecurityUserID,
              CheckerID: 0,
              LastUserID: this.currentUser.SecurityUserID,
              RejectionID: 0,
            }
    
            this.createReversal(data)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'newReversal',
                data: response.data
              });
              
              this.message = response.data.message
              this.loading = false;
              this.reverseDialog = false;
              this.reversal_description = '';
              this.ReversalReason = '';
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })
          }
        },
    
        getDetails() {
          this.message = '';
          let ID = this.currentDistribution.UnitsDistributionsId
          administrationService.queryDistributionDetails(ID)
          .then(response => {
            this.DistDetails = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },
    
        generatePDF(IsPrint) {
          const addFooters = doc => {
            const pageCount = doc.internal.getNumberOfPages()
    
            for (var i = 1; i <= pageCount; i++) {
              doc.setPage(i)
              // text is placed using x, y coordinates
              doc.setFontSize(10).text("Unit Distributions", 0.5, 0.5);
              // create a line under heading 
              doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
              doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
              doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
                align: 'center'
              })
            }
          }
    
          let doc = new jsPDF({
            orientation: "potrait",
            unit: "in",
            format: "letter"
          });
    
          doc.setFont('helvetica');
          doc.setFontSize(5);
          doc.autoTable({
            body: this.CurrentDataset,
            margin: { left: 0.5, top: 0.6 },
            styles: {overflow: 'linebreak',
                    fontSize: 6},
            showHeader: 'everyPage',
            theme: 'plain'
          });
          addFooters(doc);
          if(IsPrint == true){
            doc.output('dataurlnewwindow');
          } else{
            doc.save('Unit Distributions.pdf')
          }
        },
    
        mapCurrency(currency) {
          return this.CurrencyId = currency.CurrencyID
        },
    
        getFiltered(current){
          this.CurrentDataset = current;
        },
    
        unconfirmed() {
          this.confirmedDistributions = false
        },
    
        showEdit () {
          this.edit = true;
        },
    
        closeEdit() {
          this.currentDistribution = null,
          this.edit = false
        },
    
        showCreate () {
          this.create = true;
          this.distributed = false
        },
    
        closeCreate() {
          this.Distribution = {},
          this.create = false
        },
    
        reject () {
          this.dialog = true
        },
    
        close () {
          this.dialog = false
          this.RejectionStatus = 0
        },
    
        showMessage(){
          if(this.message){
            return true
          } else {
            return false
          }
        },
    
        validate () {
          this.$refs.form.validate()
          return this.valid
        },
    
        reset () {
          this.$refs.form.reset()
        },
    
        async setActiveDistribution (item, index) { 
          this.currentDistribution = item
          this.currentIndex = index
    
          this.getDetails()
        },
      },
    
      mounted () {
        UserService.isUnitTrust().then(
          () => {
            this.permitted = true;
            this.message = '';
          },
          error => {
            this.permitted = false;
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        this.$root.$on("unconfirmedUnitDistributions", () => {
          this.unconfirmed();
        });
      }
    }
    </script>
    
    <style scoped>
    .list {
      text-align: left;
      max-width: 750px;
      margin: auto;
    }
    
    .edit {
      background-color: #DBEFFA;
    }

    .section {
      background-color: rgb(242, 242, 242);
    }
    
    .v-btn {
      outline: none
    }
    
    /* .v-select__selections input {
      display: none;
    } */
    
    .Account {
      width: 300px;
    }
    
    .my-allocations-table{
      table-layout : fixed;
    }
    
    .table-text-field{
      width: 170px;
    }
    
    .headline {
      color:white
    }
    </style>
    